module.exports = __webpack_public_path__ + "img/stopSquare.c05892b1.svg";